import { render, staticRenderFns } from "./modal_distribute.vue?vue&type=template&id=182ca1b2&scoped=true&"
import script from "./modal_distribute.vue?vue&type=script&lang=js&"
export * from "./modal_distribute.vue?vue&type=script&lang=js&"
import style0 from "./modal_distribute.vue?vue&type=style&index=0&id=182ca1b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ca1b2",
  null
  
)

export default component.exports